import React, { memo } from 'react';
import { TextField as MaterialUiTextField } from '@mui/material';
import { IOutlinedTextFieldProps, ITextFieldProps, NeoTextField } from './NeoTextField';
import { NeoTextFieldWithIcon } from './NeoTextFieldWithIcon';
import { ChevronRight } from '@mui/icons-material';

export const TextField = memo(
  ({ newDesign, icon, options, ...props }: ITextFieldProps | IOutlinedTextFieldProps) => {
    const TextFieldProps = props as ITextFieldProps;

    const commonProps: ITextFieldProps | IOutlinedTextFieldProps = {
      color: 'primary' as 'primary',
      name: props.field?.name,
      onChange: props.field?.onChange,
      onBlur: props.field?.onBlur,
      value: props.field?.value,
      SelectProps: {
        IconComponent: ChevronRight,
      },
      variant: 'standard',
    };

    if (newDesign) {
      if (icon) {
        return <NeoTextFieldWithIcon icon={icon} {...commonProps} {...props} />;
      }
      return <NeoTextField {...commonProps} {...props} options={options} />;
    }
    return <MaterialUiTextField {...commonProps} {...TextFieldProps} />;
  },
);
